import IconNewWindow from '@picsart/icons/IconNewWindow';
import cls from 'classnames';

import useStyles from './styles';

type NavSubmenuItemProps = {
  label: string;
  href: string;
  openInNewTab?: boolean;
};

export default function NavSubmenuItem({ label, href, openInNewTab }: NavSubmenuItemProps) {
  const classes = useStyles();
  const target = openInNewTab ? '_blank' : '_self';

  return (
    <li className={cls(classes.root, openInNewTab && classes.minWidth)}>
      <a href={href} className={classes.container} target={target}>
        <span className={classes.text}>{label}</span>
        {openInNewTab && <IconNewWindow className={classes.icon} />}
      </a>
    </li>
  );
}
